import React from 'react';
import { NavLink } from 'react-router-dom';
import { ListGroupItem } from 'reactstrap';
import { startCase } from 'lodash';
import { SideNavItemObject } from './types';

interface SideNavItemProps extends SideNavItemObject {}

const SideNavItem: React.FC<SideNavItemProps> = ({
  label,
  href,
  to,
}) => (
  <ListGroupItem
    className="side-nav-item"
    action
    tag={NavLink}
    to={href ? { pathname: href } : to}
    target={href ? '_blank' : undefined}
  >
    {startCase(label)}
  </ListGroupItem>
);

export default SideNavItem;
